"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var CardType = {
  UltraSmallMobile: 'UltraSmallMobile',
  UltraSmall: 'UltraSmall',
  Small: 'Small',
  Medium: 'Medium',
  MobileMedium: 'MobileMedium',
  Wide: 'Wide',
  AdminMedium: 'AdminMedium',
  UserProfile: 'UserProfile'
};
var _default = CardType;
exports.default = _default;